export default function ({ $auth, store }) {
  if ($auth.loggedIn) {
    store.commit('user/userInfo', $auth.user)
  }
}
